import { ref } from 'vue'

import { defineStore } from 'pinia'

export const useFEDashBoardStore = defineStore('feDashBoard', () => {
  const chartProjectName = ref('')
  const statsSubTagName = ref('')
  const shortUrl = ref('')
  const subTagNumber = ref('')

  const setChartProjectName = (name: string) => {
    chartProjectName.value = name
  }

  const setStatsSubTagName = (subTagName: string) => {
    statsSubTagName.value = subTagName
  }

  const setShortUrl = (url: string) => {
    shortUrl.value = url
  }

  const setSubTagNumber = (number: string) => {
    subTagNumber.value = number
  }

  const $reset = () => {
    chartProjectName.value = ''
    statsSubTagName.value = ''
    shortUrl.value = ''
    subTagNumber.value = ''
  }

  return {
    $reset,
    chartProjectName,
    setChartProjectName,
    statsSubTagName,
    setStatsSubTagName,
    shortUrl,
    setShortUrl,
    subTagNumber,
    setSubTagNumber
  }
})
